import React, { useMemo } from 'react';
import { Device } from '@fullstory/proto/fs/api/segment';
import { OptionType, SelectMenu } from '@fullstory/components';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';

export interface DeviceSelectProps {
  device: Device;
  setDevice: (_: Device) => void;
  /** Setting this to true will disable the desktop and tablet options. */
  isNativeMobile?: boolean;
}

export const DeviceSelect: React.FC<DeviceSelectProps> = ({
  device,
  setDevice,
  isNativeMobile = false,
}) => {
  const intl = useIntl();
  const defaultDeviceOptions: OptionType<Device>[] = useMemo(
    () => [
      {
        key: 'desktop',
        label: intl.formatMessage({
          defaultMessage: 'Desktop',
          id: '+6z/UC',
          description: 'Select the desktop device',
        }),
        disabled: isNativeMobile,
        value: Device.DEVICE_DESKTOP,
      },
      {
        key: 'mobile',
        label: intl.formatMessage({
          defaultMessage: 'Mobile',
          id: 'UWbwB3',
          description: 'Select the mobile device',
        }),
        value: Device.DEVICE_MOBILE,
      },
      {
        key: 'tablet',
        label: intl.formatMessage({
          defaultMessage: 'Tablet',
          id: 'nWvm/1',
          description: 'Select the tablet device',
        }),
        disabled: isNativeMobile,
        value: Device.DEVICE_TABLET,
      },
    ],
    [intl, isNativeMobile],
  );

  return (
    <SelectMenu
      data-component="DeviceSelect"
      variant="fill-builder"
      onChange={o => {
        if (o) {
          setDevice(o.value);
        }
      }}
      options={defaultDeviceOptions}
      selected={defaultDeviceOptions.find(o => isEqual(o.value, device))}
    />
  );
};
